import React from 'react'
import { useTranslation } from 'react-i18next';

export default function ProgressChartScoreExplain(props) {

    const { scoreLabel, shouldShowChart, embedded } = props
    let label = scoreLabel || ""

    const { t, i18n } = useTranslation(['teacher_report_chart_progress'])
    const unitDescription = scoreUnitExplain(label)

    if (embedded) return null
    if (!shouldShowChart) return null
    if (!unitDescription) return null

    if (i18n.language !== 'en-us') {
        return <div className='score-unit-explain'>
            {`${t(label)}: ${t(unitDescription)}`}
        </div>
    }

    return null
}

function scoreUnitExplain(unit) {
    switch (unit) {
        case "WCPM": return "Student’s ability to read aloud with natural ease"
        case "AREA": return "Amira Reading Estimated Age"
        case "ESRI": return "Expected High Frequency Words Inventory"
        case "PSF": return "Phoneme Segmentation Fluency"
        case "EVS": return "Estimated words in vocabulary"
        case "ARM": return "Amira reading mastery"
        default: return null
    }
}